import React from "react";
import { getClassName } from "@sscs/utils";
import style from "./content.module.scss";

type ContentProps = {
  children?: React.ReactNode;
  className?: string;
  scrollContainer?: boolean;
};

const Content = ({
  children,
  className,
  scrollContainer,
}: ContentProps): React.JSX.Element => {
  return (
    <div
      className={getClassName(style["main-content"], className)}
      id="content"
      data-scroll-container={scrollContainer ? true : undefined}
    >
      {children}
    </div>
  );
};

export default Content;
